// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ProfileAvatar_avatar__3c9O7","level":"ProfileAvatar_level__3ET-i","avatar_small":"ProfileAvatar_avatar_small__3IhLg","animate":"ProfileAvatar_animate__2YOrW"};